<template lang="pug">
	header.matrixHeader(:class="{tags: Object.keys(filters).length}")
		.matrixHeader-row
			.matrixHeader-row-inner(:style="cols")
				matrix-header-cell(
					v-for="(cell, i) in computed.headers", 
					:key="cell.columnKey",
					:data="cell",
					:index="i")
				.matrixHeader-cell.matrixHeader-cell--admin(v-if="authorized")
					span.matrixHeader-cell-content
						button.matrix-save.btn.btn--secondary(v-if="authorized", @click="doSave") Save
</template>

<script>
import stickybits from "stickybits";
import HeaderCell from "./header/HeaderCell";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "MatrixHeader",
  props: ["cols"],
  components: {
    matrixHeaderCell: HeaderCell
  },
  data() {
    return {
      sticky: null
    };
  },
  computed: {
    ...mapGetters(["computed", "filters", "authorized"]),
    top() {
      return document.querySelector(".headerMain")
        ? document.querySelector(".headerMain").offsetHeight
        : 0;
    }
  },
  methods: {
    ...mapActions(["save"]),
    async doSave() {
      let id = document.querySelector("#tableId").value;
      await this.save(id);
    }
  },
  mounted() {
    let media = window.matchMedia("(min-width: 1100px)");
    media.addListener(e => {
      if (e.matches) {
        this.sticky = stickybits(this.$el, {
          useStickyClasses: true,
          stickyBitStickyOffset: this.top
        });
      } else {
        if (this.sticky) {
          this.sticky.cleanup();
        }
      }
    });
    if (media.matches) {
      this.sticky = stickybits(this.$el, {
        useStickyClasses: true,
        stickyBitStickyOffset: this.top
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.matrixHeader {
  display: flex;
  flex-direction: column;
  z-index: 2;
  @media (max-width: 1099px) {
    position: static !important;
  }
  @media (min-width: 1100px) {
    padding-top: 1.5rem;
    top: 0;
    position: sticky;
    background: $white;
    transition: margin-bottom 0.2s ease;
    &.tags {
      margin-bottom: 2rem;
    }
  }
  &.js-is-sticky::v-deep .matrixHeader-cell-category {
    opacity: 0;
  }
}

.matrixHeader-row {
  display: flex;
  flex-direction: column;
}

.matrixHeader-row-inner {
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15), 0 0 15px rgba(0, 0, 0, 0.05);
  margin: 20px;
  @media (min-width: 1100px) {
    display: grid;
    grid-template-rows: 1fr;
    grid-gap: 10px;
    box-shadow: none;
    margin: 0;
    padding: 0 1rem;
  }
}

.matrixHeader-cell--admin {
  display: none;
  @media (min-width: 1100px) {
    padding: 0.5rem 0;
    border-bottom: 1px dashed $nevada;
    display: flex;
    .matrixHeader-cell-content {
      display: flex;
      justify-content: center;
      font-size: 1rem;
      font-weight: 700;
      flex: 0 0 100%;
      margin-right: auto;
      align-self: flex-end;
      min-height: 24px;
      color: $danger;
    }
  }
}
</style>